const functionify = maybeFunction =>
  typeof maybeFunction === 'function' ? maybeFunction : () => maybeFunction;

export { functionify };
